var _mask, _path, _g, _path2, _path3, _path4, _path5, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 210,
    viewBox: "0 0 117 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_554_105",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3105 210L58.3105 210L58.3106 108L60.3106 108L60.3105 210Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3105 210L61.3105 206.94L59.3105 206.94L59.3105 210L61.3105 210ZM61.3105 202.86L61.3105 196.74L59.3105 196.74L59.3105 202.86L61.3105 202.86ZM61.3105 192.66L61.3105 186.54L59.3105 186.54L59.3105 192.66L61.3105 192.66ZM61.3105 182.46L61.3105 176.34L59.3105 176.34L59.3105 182.46L61.3105 182.46ZM61.3106 172.26L61.3106 166.14L59.3106 166.14L59.3106 172.26L61.3106 172.26ZM61.3106 162.06L61.3106 155.94L59.3106 155.94L59.3106 162.06L61.3106 162.06ZM61.3106 151.86L61.3106 145.74L59.3106 145.74L59.3106 151.86L61.3106 151.86ZM61.3106 141.66L61.3106 135.54L59.3106 135.54L59.3106 141.66L61.3106 141.66ZM61.3106 131.46L61.3106 125.34L59.3106 125.34L59.3106 131.46L61.3106 131.46ZM61.3106 121.26L61.3106 115.14L59.3106 115.14L59.3106 121.26L61.3106 121.26ZM61.3106 111.06L61.3106 108L59.3106 108L59.3106 111.06L61.3106 111.06ZM62.3105 210L62.3105 206.94L58.3105 206.94L58.3105 210L62.3105 210ZM62.3105 202.86L62.3105 196.74L58.3105 196.74L58.3105 202.86L62.3105 202.86ZM62.3105 192.66L62.3105 186.54L58.3105 186.54L58.3105 192.66L62.3105 192.66ZM62.3105 182.46L62.3105 176.34L58.3105 176.34L58.3105 182.46L62.3105 182.46ZM62.3106 172.26L62.3106 166.14L58.3106 166.14L58.3106 172.26L62.3106 172.26ZM62.3106 162.06L62.3106 155.94L58.3106 155.94L58.3106 162.06L62.3106 162.06ZM62.3106 151.86L62.3106 145.74L58.3106 145.74L58.3106 151.86L62.3106 151.86ZM62.3106 141.66L62.3106 135.54L58.3106 135.54L58.3106 141.66L62.3106 141.66ZM62.3106 131.46L62.3106 125.34L58.3106 125.34L58.3106 131.46L62.3106 131.46ZM62.3106 121.26L62.3106 115.14L58.3106 115.14L58.3106 121.26L62.3106 121.26ZM62.3106 111.06L62.3106 108L58.3106 108L58.3106 111.06L62.3106 111.06Z",
    fill: "#777777",
    mask: "url(#path-1-inside-1_554_105)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_554_105)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 105,
    height: 105,
    rx: 52.5,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9209 57.9538H68.8496V35.162C68.8496 34.6967 68.6648 34.2506 68.3358 33.9216C68.0068 33.5926 67.5607 33.4078 67.0955 33.4078C66.6302 33.4078 66.1841 33.5926 65.8551 33.9216C65.5261 34.2506 65.3413 34.6967 65.3413 35.162V36.9156C65.3416 37.0302 65.3192 37.1437 65.2754 37.2497C65.2317 37.3556 65.1675 37.4518 65.0864 37.5328C65.0054 37.6139 64.9092 37.6781 64.8032 37.7218C64.6973 37.7656 64.5838 37.788 64.4692 37.7877H39.9209V57.9538ZM50.4362 42.1643H65.3413V43.918H50.4362V42.1643ZM46.9374 42.1643H48.691V43.918H46.9374V42.1643ZM43.4291 45.6726H65.3498V47.4291H43.4291V45.6726ZM43.4291 49.1808H65.3498V50.9345H43.4291V49.1808ZM43.4291 52.6891H61.8425V54.4455H43.4291V52.6891Z",
    fill: "url(#paint0_linear_554_105)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5871 35.1592C63.5849 34.5431 63.7475 33.9376 64.058 33.4055H38.1658C37.7009 33.4063 37.2553 33.5913 36.9266 33.92C36.5979 34.2487 36.4129 34.6943 36.4121 35.1592V36.0313H63.5871V35.1592Z",
    fill: "url(#paint1_linear_554_105)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2467 43.9208H76.7385C76.2736 43.9215 75.828 44.1065 75.4993 44.4352C75.1706 44.7639 74.9856 45.2096 74.9848 45.6744V48.3011C74.9851 48.4157 74.9627 48.5293 74.919 48.6352C74.8752 48.7411 74.811 48.8373 74.7299 48.9184C74.6489 48.9994 74.5527 49.0636 74.4468 49.1074C74.3408 49.1511 74.2273 49.1735 74.1127 49.1733H70.6035V57.9434H73.7708C74.3062 57.9439 74.8288 58.1073 75.2691 58.412C75.7094 58.7167 76.0464 59.1481 76.2356 59.649L81.9994 75.0203V45.6744C81.9987 45.2097 81.8138 44.7642 81.4853 44.4356C81.1568 44.1069 80.7114 43.9218 80.2467 43.9208ZM80.2467 47.429H78.4931V45.6754H80.2467V47.429Z",
    fill: "url(#paint2_linear_554_105)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7673 59.7074H36.3077C36.1931 59.7072 36.0796 59.7296 35.9736 59.7733C35.8677 59.817 35.7715 59.8812 35.6904 59.9623C35.6094 60.0433 35.5452 60.1396 35.5014 60.2455C35.4577 60.3514 35.4353 60.4649 35.4356 60.5795C35.4351 60.6833 35.4542 60.7862 35.4921 60.8828L42.2806 78.9835H81.6107L74.5942 60.2669C74.5282 60.1015 74.4141 59.9598 74.2667 59.8601C74.1192 59.7604 73.9453 59.7072 73.7673 59.7074Z",
    fill: "url(#paint3_linear_554_105)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.3105,
    y: 210,
    width: 22,
    height: 22,
    rx: 11,
    transform: "rotate(-180 70.3105 210)",
    fill: "#FFC94F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_554_105",
    x: 0,
    y: 0,
    width: 117,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_554_105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_554_105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_105",
    x1: 54.3852,
    y1: 33.4078,
    x2: 54.3852,
    y2: 57.9538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC94F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC94F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_554_105",
    x1: 50.2351,
    y1: 33.4055,
    x2: 50.2351,
    y2: 36.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC94F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC94F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_554_105",
    x1: 76.3015,
    y1: 43.9208,
    x2: 76.3015,
    y2: 75.0203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC94F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC94F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_554_105",
    x1: 58.5231,
    y1: 59.7074,
    x2: 58.5231,
    y2: 78.9835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC94F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC94F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.d35014fa0f4c71dfe66aa41dce47ba1e.svg";
export { ForwardRef as ReactComponent };